export const agentsKeys = {
  tasks: (locationId: string) => ['agents', 'tasks', locationId] as const,
  assignment: (locationId: string) => ['agents', 'assignment', locationId] as const,
  // A location holds one mission per agent, so the agent is part of the key. Without it two
  // agents' snapshots would share one cache entry and each would render the other's work.
  mission: (locationId: string, roleKey: string) =>
    ['agents', 'mission', locationId, roleKey] as const,
  /** Every agent's mission at this location — for invalidating them together. */
  missions: (locationId: string) => ['agents', 'mission', locationId] as const,
  thread: (locationId: string, taskId: string) => ['agents', 'thread', locationId, taskId] as const,
  versions: (locationId: string, taskId: string) =>
    ['agents', 'versions', locationId, taskId] as const,
  facts: (locationId: string) => ['agents', 'facts', locationId] as const,
  dayOneReport: (locationId: string) => ['agents', 'dayOneReport', locationId] as const,
};

// Poll interval while a task panel is open — a chat reply / new version lands within this window.
// Shared by useTaskThread + useTaskVersions so both stay in lockstep.
export const AGENT_POLL_MS = 3000;

// The day-one report is written once. Poll slowly until it exists, then stop.
export const DAY_ONE_REPORT_POLL_MS = 60_000;
